module.exports = __webpack_public_path__ + "static/grafika3-7ecfec78ef4dc5200fe233026c57a324.png";